import type { EventCallable } from 'effector'

import { createEvent, sample } from 'effector'
import { model as sessionModel } from '~/entities/session'
import { appearanceFeature } from '~/features/appearance'
import { STATIC_IDENTIFIERS } from '~/shared/appearance'
import { nay } from '~/shared/helpers'
import { dynamicModuleModel } from '~/widgets/DynamicModule'
import { getHomeRowsFx } from './request'

export * from './request'

const internalInit = createEvent<{
  identifier: string
  query: URLSearchParams
}>()

export const init: EventCallable<{ query: URLSearchParams }> =
  internalInit.prepend(({ query }) => ({
    identifier: STATIC_IDENTIFIERS.HOME,
    query,
  }))
export const left = createEvent()

sample({
  clock: internalInit,
  fn: (params) => params.identifier,
  target: appearanceFeature.setIdentifier,
})

//
// components: rows + banners
//

sample({
  clock: internalInit,
  target: dynamicModuleModel.initModule,
})

sample({
  clock: left,
  source: appearanceFeature.$currentIdentifier,
  fn: (identifier) => (identifier ? { identifier } : { identifier: '' }),
  target: dynamicModuleModel.leaveModule,
})

sample({
  clock: sessionModel.$session,
  target: dynamicModuleModel.resetStructure,
})

//
// fx
//

// use custom fx for home page
sample({
  clock: [init, appearanceFeature.setIdentifier],
  source: dynamicModuleModel.$customFx,
  filter: (customFx) => nay(customFx?.[STATIC_IDENTIFIERS.HOME]),
  fn: (customFx) => ({
    ...customFx,
    [STATIC_IDENTIFIERS.HOME]: getHomeRowsFx,
  }),
  target: dynamicModuleModel.$customFx,
})
